import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import thunk from 'redux-thunk';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import { createLogger } from 'redux-logger';
import config from './configs/master';
import { LAST_LOCATION_INDEX } from './constants/shared/CommonConstants';

const { rootReducer, initialState } = config.root;

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
    savePreviousLocations: LAST_LOCATION_INDEX,
});

const hostname = window?.location?.hostname || '';
const isProduction = hostname.includes('mclass.amplify');

const configureStore = () => {
    const middlewares = [thunk, routerMiddleware];

    if (!isProduction) {
        middlewares.push(
            createLogger({
                collapsed: true,
            }),
        );
    }

    if (config.middlewares.lrsMiddleware.enabledWhen) {
        middlewares.push(config.middlewares.lrsMiddleware.instance);
    }

    const enhancer = isProduction
        ? compose(applyMiddleware(...middlewares))
        : composeWithDevTools(applyMiddleware(...middlewares));

    return createStore(rootReducer({ router: routerReducer }), initialState, enhancer);
};

const store = configureStore();

export const history = createReduxHistory(store);

export default store;
